module.exports = __webpack_public_path__ + "static/media/gddtool_output.8e0a8228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GddTool/gddtool_output.png
// module id = 1676
// module chunks = 0